module.exports = __webpack_public_path__ + "img/collectActive.17701b32.svg";